document.addEventListener("DOMContentLoaded", function () {
  const zoomButton = document.querySelector(".product__zoom-button");
  const pswpButton = document.querySelector(".pswp__button");
  const productMedia = document.querySelector("product-media");

  if (zoomButton && productMedia) {
    zoomButton.addEventListener("click", function () {
      productMedia.classList.add("zoomed_popup");
    });
  }

  if (pswpButton && productMedia) {
    pswpButton.addEventListener("click", function () {
      productMedia.classList.remove("zoomed_popup");
    });
  }
});


document.addEventListener("DOMContentLoaded", function () {
  const qty = document.querySelector('div[data-block-type="quantity-selector"]');
  const atc = document.querySelector('div[data-block-type="buy-buttons"]');

  if (qty && atc && qty.parentNode === atc.parentNode) {
    const wrapper = document.createElement('div');
    wrapper.className = 'qty_atc_wrapper';

    // Insert the wrapper before the first element
    qty.parentNode.insertBefore(wrapper, qty);

    // Move both elements into the wrapper
    wrapper.appendChild(qty);
    wrapper.appendChild(atc);
  }
});

$('.shopify-section--product-content').appendTo('.product__info');
document.addEventListener('DOMContentLoaded', () => {
  const items = document.querySelectorAll('.footer__item');

  items.forEach(item => {
    const title = item.querySelector('.footer__item-title');
    const content = item.querySelector('.footer__item-content');

    // Make title act like a button
    title.setAttribute('role', 'button');
    title.setAttribute('aria-expanded', 'false');
    title.setAttribute('tabindex', '0');

    // Click (and Enter/Space) toggles the panel
    const toggle = () => {
      const isOpen = title.getAttribute('aria-expanded') === 'true';
      title.setAttribute('aria-expanded', String(!isOpen));
      item.classList.toggle('open', !isOpen);

      if (!isOpen) {
        // expand
        content.style.maxHeight = (content.scrollHeight + 5 ) + 'px';
      } else {
        // collapse
        content.style.maxHeight = '0';
      }
    };

    title.addEventListener('click', toggle);
    title.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggle();
      }
    });
  });
});